<template>
<div>
  <v-layout>
    <v-flex   :xs4="!fullWidth">
      <v-text-field v-on:keyup.enter="$emit('search', {'search':search, 'sort':sort})" v-model="search" :label="`${$t('sort.phrase')}`"></v-text-field>
    </v-flex>
    <v-flex v-if="!sortDisable" xs2>
      <v-select  v-model="sort" :items="sortTypes" item-text='name' item-value='type' label="Sortowanie" @change="$emit('sort',{'search':search, 'sort':sort})"></v-select>
    </v-flex>
    <v-flex  xs4>
      <v-btn primary color="primary" @click="$emit('search', {'search':search, 'sort':sort})">Szukaj</v-btn>
    </v-flex>
  </v-layout>
</div>
</template>
<script>
import i18n from '@/plugins/vuei18n'
export default {
  props: ['sortDisable','fullWidth'],
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      search: "",
      sort: "DESC",
      sortTypes: [{
          'type': 'DESC',
          'name': i18n.t('sort.desc')
        },
        {
          'type': 'ASC',
          'name': i18n.t('sort.asc')
        }
      ]
    }
  }
}
</script>
